import React from "react";
import "./EqProductList.scss";
import { Col, Row } from "antd";
import EqProductCard from "../eqProductCard/EqProductCard";
import { EqEntityProductDto, EqEntityProductOrderDto } from "../../shared/interfaces/IProduct";
import { UserAndGroupOptionDto } from "../../shared/interfaces/IUserInfoDto";
// const { Meta } = Card;

export interface IEqProductList {
  productList?: EqEntityProductDto[] ;
  removeProduct?: (data: EqEntityProductDto) => void
  editProduct?: (data: EqEntityProductDto) => void
  studentsAndGroups?: UserAndGroupOptionDto[];
     onProductSend?: ( data: EqEntityProductOrderDto[]) => void;
}

const EqProductList = ({
  productList,
  removeProduct,
  editProduct,
  studentsAndGroups,
  onProductSend,
}: IEqProductList) => {
  const ProductSend = ( data: EqEntityProductOrderDto[]) => {
    onProductSend &&  onProductSend(data);
  };

  React.useEffect(() => {
    
    console.log(studentsAndGroups);
  }, [productList, studentsAndGroups]);
  return (
    <div className="prod-list">
      <Row className="eq-sl-row" align="middle">
        <Row justify="space-around" className="row">
          {productList &&
            productList.length > 0 &&
            productList.map((item, index) => (
              <Col className="col-md-4 link-category">
                <EqProductCard
                  key={index}
                  product={item}
                  studentsAndGroups={studentsAndGroups}
                  
                  removeProduct={removeProduct}
                  editProduct={editProduct}
                  onProductSend={ProductSend}
                />
              </Col>
            ))}
        </Row>
      </Row>
    </div>
  );
};

export default EqProductList;
